// src/components/Admin/Shared/ScreenshotDeterrentOverlay.jsx
//
// Lightweight copy/paste deterrent for pages showing sensitive-but-masked
// data (e.g. Prospect Call Leads). Disables the context menu and text
// selection within the wrapped region. This cannot block OS-level
// screenshots, phone photos of the screen, or screen recording — no browser
// API exists for that.
import React from 'react';

export default function ScreenshotDeterrentOverlay({ children, className = '' }) {
  return (
    <div
      className={className}
      onContextMenu={(e) => e.preventDefault()}
      style={{ userSelect: 'none', WebkitUserSelect: 'none' }}
    >
      {children}
    </div>
  );
}
